//eslint-disable-next-line no-underscore-dangle
const hasMorePredicateConfluence = (response) => !!response._links.next;
const hasMorePredicateMicros = (response) => response.hasMore === true;

// Confluence has a _links.next property, Micros does not.
export const isConfluenceResponse = (response) => !!response._links;
export const isMicrosResponse = (response) => !response._links;

export const hasMore = (response) => {
	if (!response) return false;

	//  Confluence - ._links.next
	//  Micros - .hasMore
	//eslint-disable-next-line no-underscore-dangle
	return isConfluenceResponse(response)
		? hasMorePredicateConfluence(response)
		: hasMorePredicateMicros(response);
};
